import React from "react";
import CapturingSuccessStories from "./capturing-success-stories/Capturing_Success_Stories";
import Free_Consultation from "../home/free-consultation/Free_Consultation";
import { Helmet } from "react-helmet-async";

function Gallery() {
  return (
    <>
      <Helmet>
        <title>Project Gallery | Industrial Air Compressor Installations | AYZAIR</title>
        <meta
          name="title"
          content="Project Gallery | Industrial Air Compressor Installations | AYZAIR"
        />
        <meta
          name="description"
          content="Explore AYZAIR's gallery showcasing industrial air compressor installations, compressed air systems, and successful projects across industries."
        />
        <link rel="canonical" href={"https://www.ayzair.com/gallery"} />
      </Helmet>
      <CapturingSuccessStories />
    </>
  );
}

export default Gallery;
